export const sizeBreakpoints = ['xs', 'md', 'lg'] as const;

export type AvatarSizeBreakpoint = typeof sizeBreakpoints[number];

export type AvatarSizeValue = number | string;

export type AvatarSizeProp = AvatarSizeValue | Record<AvatarSizeBreakpoint, AvatarSizeValue>;

export type AvatarClickAction = 'change' | 'default';
